import { jwtDecode } from "jwt-decode";
import { AccessTokenResponse } from "../api/types";

const tokenStorageHelper: {
  token: string;
  expireAt: string | null;
  isExpired: boolean;
  isValid: boolean;
  isInvalid: boolean;
  isUserLoggedIn: boolean;
  refreshToken: string | null;
  setTokenValues: (resp: AccessTokenResponse) => void;
  clear: () => void;
} = {
  get token() {
    return localStorage.getItem("UserToken") || "";
  },

  get expireAt() {
    return localStorage.getItem("ExpireAt");
  },

  get isExpired() {
    return tokenStorageHelper.expireAt
      ? tokenStorageHelper.expireAt < new Date().toISOString()
      : true;
  },

  get isValid() {
    return (tokenStorageHelper.token && !tokenStorageHelper.isExpired) || false;
  },

  get isInvalid() {
    return !tokenStorageHelper.isValid;
  },

  get isUserLoggedIn() {
    return tokenStorageHelper.isValid && tokenStorageHelper.token.length > 0;
  },

  get refreshToken() {
    return localStorage.getItem("RefreshToken");
  },

  setTokenValues(tokenResponse: AccessTokenResponse) {
    localStorage.setItem("UserToken", tokenResponse.token);
    localStorage.setItem("ExpireAt", tokenResponse.expireAt.toString());
  },

  clear() {
    const customObjectsSelectedTaxonomies = localStorage.getItem("customObjectsSelectedTaxonomies");
    localStorage.clear();
    if (customObjectsSelectedTaxonomies) {
      localStorage.setItem("customObjectsSelectedTaxonomies", customObjectsSelectedTaxonomies);
    }
  },
};

export default tokenStorageHelper;
